import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";

import { useAuthContext } from "@/auth/hooks/useAuthContext";
import { ErrorFallback } from "@/components/ErrorBoundary/ErrorFallback";
import { PageLoading } from "@/components/PageLoading";

import { notFound } from "./404";
import { authRoutes } from "./auth";
import { dashboard } from "./dashboard";

// Root redirect component that checks authentication
const RootRedirect = () => {
  const { authenticated, loading } = useAuthContext();

  if (loading) {
    return <PageLoading />;
  }

  return (
    <Navigate to={authenticated ? "/dashboard" : "/auth/one-id"} replace />
  );
};

export const Router = () => {
  const routes = [
    {
      path: "/",
      element: <RootRedirect />,
      errorElement: <ErrorFallback />,
    },
    ...authRoutes.map((route) => ({
      ...route,
      errorElement: <ErrorFallback />,
    })),
    ...dashboard.map((route) => ({
      ...route,
      errorElement: <ErrorFallback />,
    })),
    ...notFound,
  ];

  const router = createBrowserRouter(routes);

  return <RouterProvider router={router} />;
};
